import { AccountInformation, PartnerInformation } from 'views/CaseRedirect/CaseRedirect';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type CaseOwnerState = {
  caseId?: string;
  accountInformation?: AccountInformation | null;
  partnerInformation?: PartnerInformation | null;
};

export const initialCaseState: CaseOwnerState = {
  caseId: undefined,
  accountInformation: undefined,
  partnerInformation: undefined,
};

const caseSlice = createSlice({
  name: 'CASE',
  initialState: initialCaseState,
  reducers: {
    setAccountCaseInformation: (state, action: PayloadAction<AccountInformation | undefined>) => {
      return { ...state, accountInformation: action.payload };
    },
    setPartnerCaseInformation: (state, action: PayloadAction<PartnerInformation | undefined>) => {
      return { ...state, partnerInformation: action.payload };
    },
    setCaseId: (state, action: PayloadAction<string | undefined>) => {
      return { ...state, caseId: action.payload };
    },
  },
});

export const { setAccountCaseInformation, setPartnerCaseInformation, setCaseId } = caseSlice.actions;

export default caseSlice.reducer;
